// extracted by mini-css-extract-plugin
module.exports = {"inputUploadBtn":"inputUploadBtn-3f62f6ba","removeContent":"removeContent-64bb4105","removeFile":"removeFile-770ed1d3"};